(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["video-grid"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const popup = document.getElementById('video-popup');
  const iframe = document.getElementById('video-popup-iframe');
  const closeBtn = document.getElementById('video-popup-close');

  document.querySelectorAll('.video-grid-item').forEach(item => {
    item.addEventListener('click', function() {
      const videoUrl = this.getAttribute('data-video-url');
      let embedUrl = videoUrl;

      if (videoUrl.includes("youtube.com/watch")) {
        const videoId = new URL(videoUrl).searchParams.get("v");
        embedUrl = "https://www.youtube.com/embed/" + videoId + "?autoplay=1";
      } else if (videoUrl.includes("youtu.be/")) {
        const videoId = videoUrl.split('/').pop();
        embedUrl = "https://www.youtube.com/embed/" + videoId + "?autoplay=1";
      }

      iframe.src = embedUrl;
      popup.style.display = "flex";
    });
  });

  closeBtn.addEventListener('click', function() {
    popup.style.display = "none";
    iframe.src = "";
  });

  popup.addEventListener('click', function(e) {
    if (e.target === popup) {
      popup.style.display = "none";
      iframe.src = "";
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
